module.exports = __webpack_public_path__ + "static/media/edgecumbe-bg-2.6bd4f1b4.jpeg";